import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';
import { Box, Typography } from '@mui/material';

const BLACK_FAMILY = 'CircularStdBlack, Helvetica, Arial, sans-serif';

/** Gold letterspaced section label — replaces the old solid gold pill. */
export const SectionLabel: FC<{ children: ReactNode; muted?: boolean }> = ({
  children,
  muted,
}) => (
  <Typography
    component="div"
    sx={{
      fontFamily: BLACK_FAMILY,
      fontSize: '10.5px',
      lineHeight: 1,
      letterSpacing: '.14em',
      textTransform: 'uppercase',
      color: muted ? 'var(--muted)' : 'var(--accent-text)',
    }}
  >
    {children}
  </Typography>
);

/** Small right-slot note shown when the bio/key points are project-substituted. */
export const ScopedChip: FC<{ projectId: string }> = ({ projectId }) => (
  <Typography
    className="whitespace-nowrap"
    sx={{ fontSize: '11.5px', lineHeight: 1, color: 'var(--muted)' }}
  >
    Scoped to project #{projectId}
  </Typography>
);

interface Props {
  label: string;
  right?: ReactNode;
  span2?: boolean;
  className?: string;
  children: ReactNode;
}

/** White content card with a gold section label (shadowed, 12px radius). */
export const SectionCard: FC<Props> = ({ label, right, span2, className, children }) => (
  <Box
    className={classNames(
      'bg-surface border border-border-token rounded-xl px-5 py-5 sm:px-6 flex flex-col gap-3.5 min-w-0',
      { 'md:col-span-2': span2 },
      className
    )}
    style={{ boxShadow: 'var(--sh-2)' }}
  >
    <Box className="flex items-baseline justify-between gap-3">
      <SectionLabel>{label}</SectionLabel>
      {right}
    </Box>
    {children}
  </Box>
);

export default SectionCard;
